export default {
    add_all_materials_from_warehouse: "Add all materials from warehouse",
    add_good: "Add product",
    add_material: "Add material",
    add_new: "Add new",
    adding_new_supplier: "Adding new supplier",
    addition: "Arrival",
    address: "Address",
    adjustment: "Adjustment",
    amount: "Amount",
    amount_of_stock_on_all_warehouses: "The total quantity of goods available in all warehouses of the clinic",
    approve: "Approve",
    approved: "Approved",
    are_you_sure_you_want_to_delete_group: "Are you sure you want to delete the group?",
    are_you_sure_you_want_to_delete_kit: "Are you sure you want to delete the kit?",
    are_you_sure_you_want_to_delete_supplier: "Are you sure you want to delete the supplier?",
    are_you_sure_you_want_to_delete_warehouse: "Are you sure you want to delete the warehouse?",
    artikul: "Article",
    available_for_sale: "Available for sale",
    bank_requisites: "Bank details",
    barcode: "Barcode",
    beginning_balance: "Beginning balance",
    bin: "BIN",
    branch: "Branch",
    bulk_addition: "Add by group",
    by_categories: "By categories",
    consumption: "Expense",
    consumption_manual: "Manual expense",
    contact_person: "Contact person",
    contragent: "Counterparty",
    cost: "Price",
    created: "Created",
    current_stock: "Current balance",
    default_for_sale: "Use as default for selling products",
    default_for_writeoff: "Use as default for material write-off",
    destination: "Destination",
    details: "Details",
    difference: "Difference",
    documents: "Documents",
    draft: "Draft",
    enter_title_or_barcode: "Enter title or barcode",
    factual_amount: "Factual amount",
    finished: "Finished",
    finished2: "Finished",
    found_similar_material: "Found similar material",
    from: "From",
    from_warehouse: "Movement from warehouse",
    from_where: "From where",
    general_price: "Total amount",
    general_stock: "Total balance",
    group: "Group",
    groups: "Groups",
    id: "Id",
    in_warehouse: "In warehouse",
    inventarization: "Inventory",
    kit: "Kit",
    Kit: "Kit",
    kits: "Kits",
    material: "Material",
    materialgroup: "Group",
    materials: "Materials",
    materialstock: "Material",
    movement: "Movement",
    movement_from: "Movement",
    movement_to: "Movement",
    movements: "Movements",
    nomenclature: "Range of items",
    not_enough_material: "Not enough material",
    notify_when_stock: "Notify on balance",
    on_visit_close: "When closing a visit",
    on_visit_save: "When saving a visit",
    operation: "Operation",
    parent_category: "Parent category",
    parent_group: "Parent group",
    physical: "Physical",
    price_will_be_used_automatically_from_addition: "The price will be applied automatically from the receipt document",
    print: "Print",
    prohibit_minus_stocks: "Prohibit writing off materials into negative balance",
    prohibit_minus_stocks_in_warehouse_documents: "This setting prohibits writing off materials as a minus when filling out documents in the 'Warehouse' section",
    prohibit_minus_stocks_on_visit_closing: "Prohibit the writing off of visit materials as a minus (prohibition on completing the visit)",
    purchase_price: "Purchase price",
    return: "Return",
    returns: "Returns",
    sale_of_goods_refund: "Return of goods sales",
    sale_price: "Selling price",
    stocks: "Leftovers",
    stocks_archive: "Materials' archive",
    supplier: "Supplier",
    suppliers: "Suppliers",
    to_warehouse: "Movement to warehouse",
    to_where: "Where",
    trying_to_writeoff: "Attempt to write off",
    type: "Type",
    unit_of_measure: "Units",
    virtual: "Virtual",
    warehouse_amount: "Warehouse amount",
    warehouseoperation: "Operations",
    warehouses: "Warehouses",
    write_off: "Write off",
    write_off_materials: "Write off materials"
}
